





































































import { Component, Watch, Mixins } from "vue-property-decorator";
import { VIPCapabilityEditComponentMixin } from "@/mixins/VIPCapabilityMixin";
import dayjs from "dayjs";
import {
	db,
	busy,
	VIPCertificate,
	VIPCertificateRest,
	VIPCapabilityRest,
	VIPCapabilityCertificateRest,
	VipCertificateType,
	VIPProject,
	createEventInfo,
	getVipCapabilityTypeList,
	toaster,
} from "@/loader";
import CertificateListItem from "../certificate/CertificateListItem.vue";


@Component({
	filters: {
		log(value: any) {
			console.log(value);
			return value;
		}
	},
	components: {
		CertificateListItem,
	}
})
export default class CapabilityEdit extends Mixins(VIPCapabilityEditComponentMixin) {
	public possibleCertificates: VIPCertificate[] = [];

	public get types() {
		return getVipCapabilityTypeList();
	}

	public get ip(): number {
		return this.item.fk_ip;
	}
	public set ip(id: number) {
		this.item.fk_ip = id;
	}

	public get date(): Date | null {
		return this.item.date?.toDate() || null;
	}
	public set date(value: Date | null) {
		this.item.date = dayjs.nullable(value);
	}

	public get project(): (id: number) => VIPProject | null {
		return (id: number) => db.projects.get(id);
	}

	public get possibleCertificate(): (id: number) => VIPCertificate | null {
		return (id: number) => db.certificates.get(id);
	}

	public get certificates(): number[] {
		return this.item.certificates.map(cc => cc.fk_certificate);
	}
	public set certificates(value: number[]) {
		const { id: fk_capability } = this.item;
		value.forEach(fk_certificate => {
			if (!this.item.certificates.find(cc => cc.fk_certificate === fk_certificate)) {
				db.capabilityCertificates.insert({ fk_capability, fk_certificate });
			}
		});
		this.item.certificates.forEach(cc => {
			if (!value.find(fk_certificate => fk_certificate === cc.fk_certificate)) {
				db.capabilityCertificates.remove(cc, true);
			}
		});
	}

	public filterCertificates(options: VIPCertificate[], search: string) {
		return options.filter(x => x.project?.name.includes(search));
	}

	public reduceCertificate(option: VIPCertificate) {
		return option.id;
	}

	public save() {
		if (!this.item || !this.canEdit) {
			return;
		}
		if (!this.check()) {
			toaster.toast({ message: "Certaines informations ne sont pas valides.", variant: "warning", noAutoHide: false });
			return;
		}

		busy.start("Sauvegarde de la capacité ...");
		this.item.event = createEventInfo();
		let ids = this.item.certificates.map(cc => cc.fk_certificate);
		let p = this.isNew ? VIPCapabilityRest.create : VIPCapabilityRest.update;
		// @ts-ignore
		p(this.item).then(result => {
			if (result.success) {
				return VIPCapabilityCertificateRest.batch(this.item.id, ids);
			}
			return result;
		}).then(result => {
			if (result.success) {
				this.changed = false;
				this.unfocusAll();
				this.$emit("saved", this.item);
			}
		}).finally(() => {
			busy.stop();
		});
	}

	@Watch("ip", { immediate: true })
	public ipChanged(newValue: number, oldValue?: number) {
		if (newValue && newValue !== oldValue && this.item && this.item.ip) {
			busy.start(`Recherche des certificats liés à l'IP ${this.item.ip.code}`);
			VIPCertificateRest.list({
				fk_ip: newValue,
				type: VipCertificateType.workCertificate,
				options: { ips: true, project: true }
			}).then(result => {
				if (result.success) {
					this.possibleCertificates = result.items || [];
				} else {
					this.possibleCertificates = [];
				}
			}).finally(() => {
				busy.stop();
			});
		}
	}
}
